// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Text Colors */
  --bg-color: #ab21ca;
  --primary-text-color: #333b48;
  --secondary-text-color: #444f5f;
  --tertiary-text-color: #5d6c83;
  --quartinary-text-color: #7c8ba2;
  --quinary-text-color: #94a0b3;
  /* Surface Color */
  --main-surface-color: #f7faff;
  --primary-surface-color: #fdfdfd;
  --secondary-surface-color: #f2f4fa;
  --tertiary-surface-color: #eff3f9;
  --quartinary-surface-color: #e5ebf4;
  /* Border Color */
  --border-color: #d8e3f4;
  --border-color-selected: #d8e3f4;
  /* Accent Blue Color */
  --accent-primary-blue-color: #5095fc;
  --accent-secondary-blue-color: #73abff;
  --accent-tertiary-blue-color: #d7e7fe;
  --accent-quartinary-blue-color: #eef5ff;
  --accent-quinary-blue-color: #eef5ff;
  /* Exceptional Colors */
  --accent-exceptional-primary-blue-color: #5095fc;
  --accent-exceptional-tertiary-blue-color: #d7e7fe;
  --accent-exceptional-secondary-blue-color: #73abff;
  --tab-header-progress-bar: #eef5ff;
  --custom-dots-exceptional: #94a083;
  --custom-tab-header-color: linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);
  --custom-tab-header-quiz: linear-gradient(90deg, #5095fc 16.48%, #a0c4f8 103.36%);
  --bottom-sheet-tab-header-color: linear-gradient(90deg, #5095fc 16.48%, #a0c4f8 103.36%);
  --vrise-job-card-bg-color: linear-gradient(0deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%),
    linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);
  --vrise-application-form-header: linear-gradient(90deg, #5095fc 47.49%, #a0c4f8 121.97%);
  --vrise-error-container-bg: linear-gradient(180deg, #f1f8ff 0%, #dcebff 45.51%);
  --vrise-placed-status: linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%),
    linear-gradient(0deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%);
  --self-paced-certificate-bg: linear-gradient(90deg, #5095fc 16.48%, #a0c4f8 103.36%);
  --self-paced-certificate-progress-fill: #fdfdfd;
  --self-paced-certificate-progress-bg: #5095fc;
  --self-paced-certificate: #EEF5FF;
  --self-paced-expiry-time-warning: linear-gradient(269deg, #fdfbf3 2.09%, #fff7d7 110.8%);
  --self-paced-expection-text-color: #cb9100;
  --self-paced-exception-red-bg-color: linear-gradient(93deg, #ffc2c2 -3.6%, #ffefd7 97.6%);
  /* Accent Yellow Color */
  --accent-primary-yellow-color: #cb9100;
  --accent-secondary-yellow-color: #f9b300;
  --accent-tertiary-yellow-color: #ffefc8;
  /* Accent Orange Color */
  --accent-primary-orange-color: #e06915;
  --accent-secondary-orange-color: #fe986d;
  --accent-tertiary-orange-color: #ffe4cc;
  /* Accent Purple Color */
  --accent-primary-purple-color: #7100a5;
  --accent-secondary-purple-color: #cc67ff;
  --accent-tertiary-purple-color: #f1d9fc;
  /* Accent Dark Green Color */
  --accent-primary-dark-green-color: #3c9455;
  --accent-secondary-dark-green-color: #e2f3e7;
  /*Accent Red Color */
  --accent-primary-red-color: #ef5054;
  --accent-secondary-red-color: #fff1f1;
  /* Accent Green Color */
  --accent-primary-green-color: #62c659;
  --accent-secondary-green-color: #8af37c;
  --accent-tertiary-green-color: #ccffcb;
  /* careers mock interview cards light mode gradients */
  --scheduled-mock-bg: linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);
  --cleared-mock-bg: linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%);
  --missed-mock-bg: linear-gradient(93deg, #ffefd7 -3.6%, #ffc2c2 97.6%);
  /*Home page Banner gradient */
  --home-page-join-now: linear-gradient(91deg, #ea636d 19.11%, #f59ba0 85.37%);
  --home-page-refer-earn: linear-gradient(91deg, #6c72db 19.11%, #acb1f9 85.37%);
  --home-page-elective-selector: linear-gradient(90deg, #5095fc 100%, #a0c4f8 100%);
  --home-page-live-class-banner-status: #fff1f1;
  --home-page-refer-earn-banner-status: #f1d9fc;
  --home-page-elective-selector-status: #d7e7fe;
  --home-page-banner-time: #fdfdfd;
  --refer-earn-banner-strip: linear-gradient(90deg, #5095fc 0%, #4652ad 100%);
  --skill-test-ai-tabs: #fdfdfd;
  /* additional gradients */
  --homepage-dropdown-gradient: linear-gradient(90deg, #5095fc 16.33%, #a0c4f8 132.4%);
  --profile-tab-header-gradient: linear-gradient(90deg, #5095fc 16.48%, #a0c4f8 103.36%);
  --assignment-text-box-gradient: linear-gradient(180deg, #fdfdfd 60.16%, #fdfdfd 112.5%);
  --quiz-box-linear-gradient: linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%);
  --quiz-box-attempt-linear-gradient: linear-gradient(93deg, #d7fff8 -3.6%, #cdebfb 45.24%, #c2d5ff 97.6%),
    var(--Color-Surface-Secondary, #f2f4fa);
  --quiz-grade-text-linear-gradient: #5d6c83;
  /* Refer and Earn */
  --refer-earn-main-surface: linear-gradient(180deg, #dee9ff 0%, #f9fbff 100%);
  --refer-earn-form-surface: #ffffff;
  --refer-earn-form-heading: linear-gradient(180deg, #5095fc 0%, #99bbed 100%);
  --refer-earn-form-bg: #ffffff;
  --refer-earn-benefit-container: #e9f2ff;
  /* extras */
  --forum-confirmation-drop-shadow: rgba(253, 253, 253, 0.7);
  --feedback-widget-gradient: linear-gradient(180deg, rgba(247, 250, 255, 0) 0%, #ebf3ff 41.67%);
  --toast-warning-gradient: linear-gradient(93deg, #fffac9 -3.6%, #ffdfa1 97.6%);
  --profile-side-arrow: linear-gradient(270deg, #f7faff 23.33%, rgba(247, 250, 255, 0) 150.83%);
  --profile-success-gradient-bg: linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);
  --prt-bg-color: linear-gradient(0deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.6) 100%),
    linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);
  /* PRT Skill test Gradient */
  --prt-skill-test-good: linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%);
  --prt-skill-test-average: linear-gradient(274deg, #ffd290 -17.2%, #fff7d7 136.15%);
  --prt-skill-test-bad: linear-gradient(93deg, #ffefd7 -3.6%, #ffc2c2 97.6%);
  --prt-skill-test-tab-header: #f7faff;
  --prt-skill-test-border-color: #fdfdfd;
  --vlearn-walkthrough: linear-gradient(to right, #e3a8ff -2.04%, #5095fc 100%);
  /*Excel */
  --excel-grid-bg: #dcffdb;
}

[data-theme=dark] {
  /* Text Colors */
  --bg-color: #121212;
  --primary-text-color: #ffffff;
  --secondary-text-color: #d3d3d3;
  --tertiary-text-color: #c8c8c8;
  --quartinary-text-color: #a8a8a8;
  --quinary-text-color: #646464;
  /* Surface Color */
  --main-surface-color: #121212;
  --primary-surface-color: #1e1e1e;
  --secondary-surface-color: #232323;
  --tertiary-surface-color: #2a2a2a;
  --quartinary-surface-color: #333333;
  /* Border Color */
  --border-color: #3c3c3c;
  --border-color-selected: #a8a8a8;
  /* Accent Blue Color */
  --accent-primary-blue-color: #5095fc;
  --accent-secondary-blue-color: #5676a1;
  --accent-tertiary-blue-color: #4a668d;
  --accent-quartinary-blue-color: #eef5ff;
  --accent-quinary-blue-color: #333333;
  /* Exceptional Colors */
  --accent-exceptional-primary-blue-color: #d7e7fe;
  --accent-exceptional-tertiary-blue-color: #2a2a2a;
  --accent-exceptional-secondary-blue-color: #7fa4dc;
  --custom-dots-exceptional: #333333;
  --custom-tab-header-color: #2a2a2a;
  --custom-tab-header-quiz: #2a2a2a;
  --bottom-sheet-tab-header-color: #2a2a2a;
  --tab-header-progress-bar: #4a668d;
  --self-paced-certificate: #73abff;
  --self-paced-certificate-bg: linear-gradient(90deg, #1c2441 -2.26%, #000b26 100%);
  --self-paced-certificate-progress-fill: #5095fc;
  --self-paced-certificate-progress-bg: #4a668d;
  --self-paced-expiry-time-warning: linear-gradient(92deg, #453621 1.42%, #28231b 100.29%);
  --self-paced-expection-text-color: #ffcc49;
  --self-paced-exception-red-bg-color: linear-gradient(111deg, #452121 5.2%, #2a241c 96.2%);
  /* Accent Yellow Color */
  --accent-primary-yellow-color: #fff0c0;
  --accent-secondary-yellow-color: #ffcc49;
  --accent-tertiary-yellow-color: #b5842a;
  /* Accent Orange Color */
  --accent-primary-orange-color: #ffddc0;
  --accent-secondary-orange-color: #ff9365;
  --accent-tertiary-orange-color: #c15436;
  /* Accent Purple Color */
  --accent-primary-purple-color: #f1d9fc;
  --accent-secondary-purple-color: #b37cf3;
  --accent-tertiary-purple-color: #694a8d;
  /* Accent Dark Green Color */
  --accent-primary-dark-green-color: #37da66;
  --accent-secondary-dark-green-color: #47594c;
  /*Accent Red Color */
  --accent-primary-red-color: #ff6a71;
  --accent-secondary-red-color: #594747;
  /*Accent Green Color */
  --accent-primary-green-color: #dafcd9;
  --accent-secondary-green-color: #7cf38a;
  --accent-tertiary-green-color: #4c8d4a;
  --scheduled-mock-bg: linear-gradient(114deg, #488f82 3.61%, #3c3c3c 97.06%);
  --cleared-mock-bg: linear-gradient(114deg, #53895c 3.61%, #3c3c3c 97.06%);
  --missed-mock-bg: linear-gradient(114deg, #9f4a4a 3.61%, #3c3c3c 97.06%);
  /*Home page Banner gradient */
  --home-page-join-now: linear-gradient(92deg, #481a1a 0%, #3e0000 64.67%);
  --home-page-refer-earn: linear-gradient(90deg, #2c1b40 -2.26%, #160025 100%);
  --home-page-elective-selector: linear-gradient(90deg, #1c2441 -2.26%, #000b26 100%);
  --home-page-live-class-banner-status: #ff6a71;
  --home-page-refer-earn-banner-status: #b37cf3;
  --home-page-elective-selector-status: #5095fc;
  --home-page-banner-time: #d3d3d3;
  /* additional gradients */
  --homepage-dropdown-gradient: #333333;
  --profile-tab-header-gradient: #2a2a2a;
  --assignment-text-box-gradient: "";
  --quiz-box-linear-gradient: linear-gradient(114deg, #53895c 3.61%, #3c3c3c 97.06%);
  --quiz-box-attempt-linear-gradient: linear-gradient(114deg, #488f82 3.61%, #3c3c3c 97.06%);
  --quiz-grade-text-linear-gradient: #ffffff;
  /* Refer and Earn */
  --refer-earn-main-surface: linear-gradient(180deg, #001a3d 0%, #121212 100%);
  --refer-earn-form-surface: "";
  --refer-earn-form-heading: #2a2a2a;
  --refer-earn-form-bg: #1e1e1e;
  --refer-earn-benefit-container: #333333;
  /* extras */
  --forum-confirmation-drop-shadow: rgba(0, 0, 0, 0.7);
  --feedback-widget-gradient: transparent;
  --darktheme-loader-bg: #2a2a2a;
  --darktheme-loader-foreground: #1e1e1e;
  --refer-earn-banner-strip: #5676a1;
  --toast-warning-gradient: linear-gradient(114deg, #9f8e4a 3.61%, #3c3c3c 97.06%);
  --profile-side-arrow: "";
  --profile-success-gradient-bg: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    linear-gradient(90deg, #394b84 -2.26%, #00154b 100%);
  --skill-test-ai-tabs: #5676a1;
  --prt-bg-color: #232323;
  /* PRT Skill test Gradient */
  --prt-skill-test-good: linear-gradient(117deg, #53895c 3.44%, #3c3c3c 155.25%);
  --prt-skill-test-average: linear-gradient(117deg, #af8952 3.43%, #3c3c3c 143.98%);
  --prt-skill-test-bad: linear-gradient(118deg, #9f4a4a 3.37%, #3c3c3c 141.01%);
  --prt-skill-test-tab-header: #1e1e1e;
  --prt-skill-test-border-color: #3c3c3c;
  --vlearn-walkthrough: linear-gradient(to right, #d377ff -2.04%, #67a4ff 100%);
  --excel-grid-bg: #4c8d4a;
  --vrise-job-card-bg-color: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    linear-gradient(90deg, #394b84 -2.26%, #00154b 100%);
  --vrise-application-form-header: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    linear-gradient(90deg, #394b84 -2.26%, #00154b 100%);
  --vrise-error-container-bg: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    linear-gradient(180deg, #394b84 0%, #00154b 100%);
  --vrise-placed-status: linear-gradient(143deg, #266731 -96.5%, #1e1e1e 107.44%);
}

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.full-height {
  height: calc(100vh - 90px);
}

p {
  margin: 0;
  padding: 0;
}

.bounceInRight {
  -webkit-animation-name: bounceInRight;
  animation-name: bounceInRight;
}

.custom-loader {
  position: relative;
  height: 100%;
  width: 100%;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.icon-filled {
  font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 0, "opsz" 48;
}

.no-pointer {
  cursor: not-allowed !important;
}

.zoom-join-button-text {
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  cursor: pointer;
}

.Course-card-header-program-name-text {
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  color: #333b48;
  text-transform: capitalize;
  text-overflow: ellipsis;
  white-space: normal;
  font-size: 16px;
}

@media (max-width: 769px) {
  .Course-card-header {
    display: flex !important;
    flex-wrap: wrap !important;
  }
  .Course-card-header .Course-card-header-program-name-text {
    font-size: 14px;
  }
  .Course-card-header .course-card-img {
    width: 70px;
  }
  .Course-card-header .Course-card-header-middle-column {
    flex-grow: 1;
  }
  .Course-card-header .Course-card-header-program-name {
    max-width: auto !important;
  }
}

.d-none {
  display: none !important;
}

.d-block {
  display: block !important;
}

.d-flex {
  display: flex !important;
}

.w-100 {
  width: 100% !important;
}

.h-100 {
  height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

/* Flexbox Utilities */
.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

/* Margin and Padding Utilities */
.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

/* Other margin classes omitted for brevity */
.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

/* Other padding classes omitted for brevity */
/* Display Utilities */
.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.h-auto {
  height: auto !important;
}

.w-auto {
  width: auto !important;
}

p {
  margin-bottom: 1rem;
}

/* Padding Top */
.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

/* Padding Left */
.pl-0 {
  padding-left: 0 !important;
}

.pl-1 {
  padding-left: 0.25rem !important;
}

.pl-2 {
  padding-left: 0.5rem !important;
}

.pl-3 {
  padding-left: 1rem !important;
}

.pl-4 {
  padding-left: 1.5rem !important;
}

.pl-5 {
  padding-left: 3rem !important;
}

/* Padding Bottom */
.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

/* Padding Right */
.pr-0 {
  padding-right: 0 !important;
}

.pr-1 {
  padding-right: 0.25rem !important;
}

.pr-2 {
  padding-right: 0.5rem !important;
}

.pr-3 {
  padding-right: 1rem !important;
}

.pr-4 {
  padding-right: 1.5rem !important;
}

.pr-5 {
  padding-right: 3rem !important;
}

/* Margin Top */
.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

/* Margin Bottom */
.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

/* Margin Left */
.ml-0 {
  margin-left: 0 !important;
}

.ml-1 {
  margin-left: 0.25rem !important;
}

.ml-2 {
  margin-left: 0.5rem !important;
}

.ml-3 {
  margin-left: 1rem !important;
}

.ml-4 {
  margin-left: 1.5rem !important;
}

.ml-5 {
  margin-left: 3rem !important;
}

/* Margin Right */
.mr-0 {
  margin-right: 0 !important;
}

.mr-1 {
  margin-right: 0.25rem !important;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.mr-3 {
  margin-right: 1rem !important;
}

.mr-4 {
  margin-right: 1.5rem !important;
}

.mr-5 {
  margin-right: 3rem !important;
}

h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h2 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h5 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

p {
  margin: 0;
  padding: 0;
}

.slick-dots .slick-active .customDots {
  width: 28px !important;
  background: #5095fc !important;
}

.slick-dots {
  bottom: -16px !important;
}
.slick-dots li {
  margin: 0 8px !important;
  width: fit-content !important;
  height: fit-content !important;
}
.slick-dots li:first-child {
  margin-right: 0px !important;
}

.zoom-mobile-view {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(249deg, #c2d5ff 26%, #d7fff8 73.92%);
}
.zoom-mobile-view-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.zoom-trying-img {
  width: 100%;
  height: calc(100vh - 420px);
}
@supports (-webkit-touch-callout: none) {
  .zoom-trying-img {
    height: calc(100vh - 450px);
    object-fit: contain;
  }
}
@media screen and (min-height: 730px) {
  .zoom-trying-img {
    height: 45vh;
    padding-top: 60px;
  }
}
@media screen and (min-height: 850px) {
  .zoom-trying-img {
    height: 45vh;
    padding-top: 80px;
  }
}

.zoom-mobile-img {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.zoom-mobile-img .zoom-background-img {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
}

.zoom-mobile-bottom-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 320px;
  width: 100vw;
  padding: 28px 16px 24px 16px;
  gap: 24px;
  background-color: white;
  border-radius: 30px 30px 0px 0px;
  border: 2px solid var(--Color-Surface-Primary, #fdfdfd);
  background: #f0f4ff;
  box-shadow: 0px -4px 16px 0px rgba(147, 172, 214, 0.3);
}
@media screen and (min-height: 820px) {
  .zoom-mobile-bottom-container {
    height: 42vh;
  }
}
.zoom-mobile-bottom-container p {
  margin: 0;
  padding: 0;
}
.zoom-mobile-bottom-container .zoom-mobile-heading {
  color: #5095fc;
  font-size: 20px;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  width: 100%;
  text-align: center;
}
.zoom-mobile-bottom-container .zoom-mobile-subHeading {
  color: #000;
  text-align: center;
  font-size: 14px;
  line-height: 150%;
  margin-top: 12px;
  font-family: "Regular Sans", sans-serif;
  font-style: normal;
  color: var(--Color-Text-Primary, #333b48);
  text-align: center;
}
.zoom-mobile-bottom-container .app-store-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
}
.zoom-mobile-bottom-container .app-store-button img {
  width: 167px;
}
@media (max-width: 375px) {
  .zoom-mobile-bottom-container .app-store-button img {
    width: 40vw;
  }
}
.zoom-mobile-bottom-container .continue-browser {
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-family: "Roboto";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  text-decoration-line: underline;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.zoom-mobile-bottom-container .or-button {
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-family: "Roboto";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
}

.left-short-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.left-short-img .left-short-img-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
  padding: 0 40px;
}
.left-short-img .left-short-img-container .app-store-button {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.left-short-img .left-short-img-container .app-store-button img {
  width: 160px;
  height: 52px;
}
.left-short-img img {
  width: 192px;
  height: 34px;
}
.left-short-img h6 {
  color: var(--Color-Accent-Shade-1, #5095fc);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 125%;
  margin: 0;
}
.left-short-img p {
  margin: 0;
  margin-top: 12px;
  color: var(--Color-Text-Primary, #333b48);
  font-family: "Regular Sans", sans-serif;
  font-style: normal;
  font-size: 18px;
  line-height: 150%;
}
@media (max-width: 765px) {
  .left-short-img h6 {
    font-size: 24px;
  }
  .left-short-img p {
    font-size: 16px;
  }
}

input {
  background-color: var(--primary-surface-color) !important;
}
input::placeholder {
  color: #94A0B3 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/themeMapping.scss","webpack://./src/styles/globals.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EAEA,kBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kCAAA;EACA,iCAAA;EACA,mCAAA;EAEA,iBAAA;EACA,uBAAA;EACA,gCAAA;EAEA,sBAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,uCAAA;EACA,oCAAA;EAEA,uBAAA;EACA,gDAAA;EACA,iDAAA;EACA,kDAAA;EACA,kCAAA;EACA,kCAAA;EACA,mFAAA;EACA,iFAAA;EACA,wFAAA;EACA;4DAAA;EAEA,wFAAA;EACA,+EAAA;EACA;qFAAA;EAEA,oFAAA;EACA,+CAAA;EACA,6CAAA;EACA,iCAAA;EACA,wFAAA;EACA,0CAAA;EACA,yFAAA;EACA,wBAAA;EACA,sCAAA;EACA,wCAAA;EACA,uCAAA;EAEA,wBAAA;EACA,sCAAA;EACA,wCAAA;EACA,uCAAA;EAEA,wBAAA;EACA,sCAAA;EACA,wCAAA;EACA,uCAAA;EAEA,4BAAA;EACA,0CAAA;EACA,4CAAA;EAEA,oBAAA;EACA,mCAAA;EACA,qCAAA;EAEA,uBAAA;EACA,qCAAA;EACA,uCAAA;EACA,sCAAA;EAEA,sDAAA;EACA,6EAAA;EACA,yEAAA;EACA,sEAAA;EAEA,6BAAA;EACA,4EAAA;EACA,8EAAA;EACA,iFAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,gCAAA;EACA,2EAAA;EACA,6BAAA;EAEA,yBAAA;EACA,oFAAA;EACA,sFAAA;EACA,uFAAA;EACA,kFAAA;EACA;2CAAA;EAEA,0CAAA;EAEA,mBAAA;EACA,4EAAA;EACA,kCAAA;EACA,4EAAA;EACA,6BAAA;EACA,uCAAA;EACA,WAAA;EACA,0DAAA;EACA,8FAAA;EACA,8EAAA;EACA,6FAAA;EACA,uFAAA;EACA;4DAAA;EAGA,4BAAA;EACA,6EAAA;EACA,kFAAA;EACA,0EAAA;EACA,oCAAA;EACA,sCAAA;EACA,6EAAA;EAEA,SAAA;EACA,wBAAA;ACdF;;ADiBA;EACE,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EAEA,kBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kCAAA;EACA,iCAAA;EACA,mCAAA;EAEA,iBAAA;EACA,uBAAA;EACA,gCAAA;EAEA,sBAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,uCAAA;EACA,oCAAA;EAEA,uBAAA;EACA,gDAAA;EACA,iDAAA;EACA,kDAAA;EACA,kCAAA;EACA,kCAAA;EACA,iCAAA;EACA,wCAAA;EACA,kCAAA;EACA,iCAAA;EACA,iFAAA;EACA,+CAAA;EACA,6CAAA;EACA,wFAAA;EACA,0CAAA;EACA,yFAAA;EACA,wBAAA;EACA,sCAAA;EACA,wCAAA;EACA,uCAAA;EAEA,wBAAA;EACA,sCAAA;EACA,wCAAA;EACA,uCAAA;EAEA,wBAAA;EACA,sCAAA;EACA,wCAAA;EACA,uCAAA;EAEA,4BAAA;EACA,0CAAA;EACA,4CAAA;EAEA,oBAAA;EACA,mCAAA;EACA,qCAAA;EAEA,sBAAA;EACA,qCAAA;EACA,uCAAA;EACA,sCAAA;EAGA,2EAAA;EACA,yEAAA;EACA,wEAAA;EAEA,6BAAA;EACA,wEAAA;EACA,4EAAA;EACA,mFAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,gCAAA;EAEA,yBAAA;EACA,qCAAA;EACA,sCAAA;EACA,kCAAA;EACA,kFAAA;EACA,0FAAA;EACA,0CAAA;EAEA,mBAAA;EACA,4EAAA;EACA,6BAAA;EACA,kCAAA;EACA,6BAAA;EACA,uCAAA;EACA,WAAA;EACA,oDAAA;EACA,uCAAA;EACA,8BAAA;EACA,sCAAA;EACA,kCAAA;EACA,gFAAA;EACA,wBAAA;EACA;wDAAA;EAEA,6BAAA;EACA,uBAAA;EAEA,4BAAA;EACA,8EAAA;EACA,iFAAA;EACA,6EAAA;EACA,oCAAA;EACA,sCAAA;EACA,6EAAA;EACA,wBAAA;EACA;wDAAA;EAEA;wDAAA;EAGA;qDAAA;EAGA,+EAAA;AC/BF;;AA/NA;EACE,mCAAA;EACA,kCAAA;AAkOF;;AAhOA;EACE,0BAAA;AAmOF;;AAjOA;EACE,SAAA;EACA,UAAA;AAoOF;;AA9NA;EACE,qCAAA;EACA,6BAAA;AAiOF;;AA/NA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAkOF;;AAhOA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,WAAA;AAmOF;;AAjOA;EACE,kEAAA;AAoOF;;AAlOA;EACE,8BAAA;AAqOF;;AAnOA;ECJE,oCAAA;EACA,kBAAA;EACA,gBAAA;EDIA,eAAA;AAwOF;;AAtOA;ECbE,sCAAA;EACA,kBAAA;EACA,gBAAA;EDaA,cAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA2OF;;AAxOE;EADF;IAEI,wBAAA;IACA,0BAAA;EA4OF;EA3OE;IACE,eAAA;EA6OJ;EA3OE;IACE,WAAA;EA6OJ;EA1OE;IACE,YAAA;EA4OJ;EA1OE;IACE,0BAAA;EA4OJ;AACF;;AAzOA;EACE,wBAAA;AA4OF;;AA1OA;EACE,yBAAA;AA6OF;;AA3OA;EACE,wBAAA;AA8OF;;AA5OA;EACE,sBAAA;AA+OF;;AA7OA;EACE,uBAAA;AAgPF;;AA9OA;EACE,wBAAA;AAiPF;;AA/OA;EACE,uBAAA;AAkPF;;AA/OA,sBAAA;AACA;EACE,8BAAA;AAkPF;;AAhPA;EACE,iCAAA;AAmPF;;AAjPA;EACE,sCAAA;AAoPF;;AAlPA;EACE,yCAAA;AAqPF;;AAnPA;EACE,uBAAA;AAsPF;;AApPA;EACE,uBAAA;AAuPF;;AArPA;EACE,yBAAA;AAwPF;;AAtPA;EACE,yBAAA;AAyPF;;AAvPA;EACE,0BAAA;AA0PF;;AAxPA;EACE,4BAAA;AA2PF;;AAzPA;EACE,kCAAA;AA4PF;;AA1PA;EACE,sCAAA;AA6PF;;AA3PA;EACE,oCAAA;AA8PF;;AA5PA;EACE,kCAAA;AA+PF;;AA7PA;EACE,yCAAA;AAgQF;;AA9PA;EACE,wCAAA;AAiQF;;AA/PA;EACE,wCAAA;AAkQF;;AAhQA;EACE,kCAAA;AAmQF;;AAjQA;EACE,gCAAA;AAoQF;;AAlQA;EACE,8BAAA;AAqQF;;AAnQA;EACE,gCAAA;AAsQF;;AApQA;EACE,+BAAA;AAuQF;;AArQA;EACE,oCAAA;AAwQF;;AAtQA;EACE,kCAAA;AAyQF;;AAvQA;EACE,gCAAA;AA0QF;;AAxQA;EACE,uCAAA;AA2QF;;AAzQA;EACE,sCAAA;AA4QF;;AA1QA;EACE,iCAAA;AA6QF;;AA3QA;EACE,2BAAA;AA8QF;;AA5QA;EACE,iCAAA;AA+QF;;AA7QA;EACE,+BAAA;AAgRF;;AA9QA;EACE,6BAAA;AAiRF;;AA/QA;EACE,+BAAA;AAkRF;;AAhRA;EACE,8BAAA;AAmRF;;AAhRA,iCAAA;AACA;EACE,oBAAA;AAmRF;;AAjRA;EACE,0BAAA;AAoRF;;AAlRA;EACE,yBAAA;AAqRF;;AAnRA;EACE,uBAAA;AAsRF;;AApRA;EACE,yBAAA;AAuRF;;AArRA;EACE,uBAAA;AAwRF;;AAtRA;EACE,uBAAA;AAyRF;;AAvRA,6CAAA;AAEA;EACE,qBAAA;AAyRF;;AAvRA;EACE,2BAAA;AA0RF;;AAxRA;EACE,0BAAA;AA2RF;;AAzRA;EACE,wBAAA;AA4RF;;AA1RA;EACE,0BAAA;AA6RF;;AA3RA;EACE,wBAAA;AA8RF;;AA5RA,8CAAA;AAEA,sBAAA;AACA;EACE,0BAAA;AA8RF;;AA5RA;EACE,gCAAA;AA+RF;;AA7RA;EACE,yBAAA;AAgSF;;AA7RA;EACE,yBAAA;AAgSF;;AA9RA;EACE,6BAAA;AAiSF;;AA/RA;EACE,wBAAA;AAkSF;;AAhSA;EACE,+BAAA;AAmSF;;AAjSA;EACE,wBAAA;AAoSF;;AAjSA;EACE,uBAAA;AAoSF;;AAlSA;EACE,sBAAA;AAqSF;;AAnSA;EACE,mBAAA;AAsSF;;AApSA,gBAAA;AACA;EACE,yBAAA;AAuSF;;AArSA;EACE,+BAAA;AAwSF;;AAtSA;EACE,8BAAA;AAySF;;AAvSA;EACE,4BAAA;AA0SF;;AAxSA;EACE,8BAAA;AA2SF;;AAzSA;EACE,4BAAA;AA4SF;;AAzSA,iBAAA;AACA;EACE,0BAAA;AA4SF;;AA1SA;EACE,gCAAA;AA6SF;;AA3SA;EACE,+BAAA;AA8SF;;AA5SA;EACE,6BAAA;AA+SF;;AA7SA;EACE,+BAAA;AAgTF;;AA9SA;EACE,6BAAA;AAiTF;;AA9SA,mBAAA;AACA;EACE,4BAAA;AAiTF;;AA/SA;EACE,kCAAA;AAkTF;;AAhTA;EACE,iCAAA;AAmTF;;AAjTA;EACE,+BAAA;AAoTF;;AAlTA;EACE,iCAAA;AAqTF;;AAnTA;EACE,+BAAA;AAsTF;;AAnTA,kBAAA;AACA;EACE,2BAAA;AAsTF;;AApTA;EACE,iCAAA;AAuTF;;AArTA;EACE,gCAAA;AAwTF;;AAtTA;EACE,8BAAA;AAyTF;;AAvTA;EACE,gCAAA;AA0TF;;AAxTA;EACE,8BAAA;AA2TF;;AAxTA,eAAA;AACA;EACE,wBAAA;AA2TF;;AAzTA;EACE,8BAAA;AA4TF;;AA1TA;EACE,6BAAA;AA6TF;;AA3TA;EACE,2BAAA;AA8TF;;AA5TA;EACE,6BAAA;AA+TF;;AA7TA;EACE,2BAAA;AAgUF;;AA7TA,kBAAA;AACA;EACE,2BAAA;AAgUF;;AA9TA;EACE,iCAAA;AAiUF;;AA/TA;EACE,gCAAA;AAkUF;;AAhUA;EACE,8BAAA;AAmUF;;AAjUA;EACE,gCAAA;AAoUF;;AAlUA;EACE,8BAAA;AAqUF;;AAlUA,gBAAA;AACA;EACE,yBAAA;AAqUF;;AAnUA;EACE,+BAAA;AAsUF;;AApUA;EACE,8BAAA;AAuUF;;AArUA;EACE,4BAAA;AAwUF;;AAtUA;EACE,8BAAA;AAyUF;;AAvUA;EACE,4BAAA;AA0UF;;AAvUA,iBAAA;AACA;EACE,0BAAA;AA0UF;;AAxUA;EACE,gCAAA;AA2UF;;AAzUA;EACE,+BAAA;AA4UF;;AA1UA;EACE,6BAAA;AA6UF;;AA3UA;EACE,+BAAA;AA8UF;;AA5UA;EACE,6BAAA;AA+UF;;AA5UA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA+UF;;AA5UA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA+UF;;AA5UA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA+UF;;AA5UA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA+UF;;AA5UA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA+UF;;AA5UA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA+UF;;AA7UA;EACE,SAAA;EACA,UAAA;AAgVF;;AA7UA;EACE,sBAAA;EACA,8BAAA;AAgVF;;AA9UA;EACE,wBAAA;AAiVF;AAhVE;EACE,wBAAA;EACA,6BAAA;EACA,8BAAA;AAkVJ;AAhVE;EACE,4BAAA;AAkVJ;;AA/UA;EACE,aAAA;EACA,YAAA;ECzfA,aAAA;EACA,sBDyfc;ECxfd,mBAHyC;EAIzC,uBAJmE;ED4fnE,gBAAA;EACA,gEAAA;AAqVF;AApVE;EC7fA,aAAA;EACA,mBAFsB;EAGtB,mBAHyC;EAIzC,uBAJmE;EDggBjE,aAAA;AAyVJ;;AAtVA;EACE,WAAA;EAMA,2BAAA;AAoVF;AAxVE;EAHF;IAII,2BAAA;IACA,mBAAA;EA2VF;AACF;AApVE;EAbF;IAcI,YAAA;IACA,iBAAA;EAuVF;AACF;AArVE;EAlBF;IAmBI,YAAA;IACA,iBAAA;EAwVF;AACF;;AArVA;EACE,YAAA;EC3hBA,aAAA;EACA,sBD2hBc;EC1hBd,mBD0hBsB;ECzhBtB,2BDyhB8B;AA2VhC;AAzVE;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,sBAAA;AA2VJ;;AAvVA;EACE,YAAA;ECxiBA,aAAA;EACA,sBDwiBc;ECviBd,mBDuiBsB;ECtiBtB,2BDsiB8B;EAC9B,aAAA;EACA,YAAA;EAMA,4BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;EACA,uDAAA;EACA,mBAAA;EACA,sDAAA;AAwVF;AAlWE;EANF;IAOI,YAAA;EAqWF;AACF;AA5VE;EACE,SAAA;EACA,UAAA;AA8VJ;AA5VE;EACE,cAAA;EACA,eAAA;ECrhBF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDqhBE,iBAAA;EACA,WAAA;EACA,kBAAA;AAgWJ;AA9VE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;ECziBF,uCAAA;EACA,kBAAA;ED0iBE,yCAAA;EACA,kBAAA;AAiWJ;AA/VE;EC9kBA,aAAA;EACA,mBAFsB;EAGtB,mBAHyC;EAIzC,uBAJmE;EDilBjE,WAAA;EACA,SAAA;AAoWJ;AAlWI;EACE,YAAA;AAoWN;ACzwBE;EDoaE;IAGI,WAAA;EAsWN;AACF;AAnWE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EClVF,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,wCAAA;ADwrBF;AAzWE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AA2WJ;;AAvWA;EChnBE,aAAA;EACA,sBDgnBc;EC/mBd,mBAHyC;EAIzC,uBAJmE;AD+9BrE;AA5WE;EClnBA,aAAA;EACA,sBDknBgB;ECjnBhB,uBDinBwB;EChnBxB,2BDgnBoC;EAClC,SAAA;EACA,eAAA;AAiXJ;AAhXI;ECtnBF,aAAA;EACA,mBDsnBkB;ECrnBlB,uBDqnBuB;ECpnBvB,2BDonBmC;EAC/B,SAAA;EACA,eAAA;AAqXN;AApXM;EACE,YAAA;EACA,YAAA;AAsXR;AAlXE;EACE,YAAA;EACA,YAAA;AAoXJ;AAlXE;EACE,2CAAA;EC5lBF,oCAAA;EACA,kBAAA;EACA,gBAAA;ED4lBE,eAAA;EACA,iBAAA;EACA,SAAA;AAsXJ;AApXE;EACE,SAAA;EACA,gBAAA;EACA,yCAAA;EC9mBF,uCAAA;EACA,kBAAA;ED+mBE,eAAA;EACA,iBAAA;AAuXJ;ACn6BE;ED+iBE;IACE,eAAA;EAuXJ;EArXE;IACE,eAAA;EAuXJ;AACF;;AAnXA;EACE,yDAAA;AAsXF;AArXE;EACE,yBAAA;AAuXJ","sourcesContent":[":root {\n  /* Text Colors */\n  --bg-color: #ab21ca;\n  --primary-text-color: #333b48;\n  --secondary-text-color: #444f5f;\n  --tertiary-text-color: #5d6c83;\n  --quartinary-text-color: #7c8ba2;\n  --quinary-text-color: #94a0b3;\n\n  /* Surface Color */\n  --main-surface-color: #f7faff;\n  --primary-surface-color: #fdfdfd;\n  --secondary-surface-color: #f2f4fa;\n  --tertiary-surface-color: #eff3f9;\n  --quartinary-surface-color: #e5ebf4;\n\n  /* Border Color */\n  --border-color: #d8e3f4;\n  --border-color-selected: #d8e3f4;\n\n  /* Accent Blue Color */\n  --accent-primary-blue-color: #5095fc;\n  --accent-secondary-blue-color: #73abff;\n  --accent-tertiary-blue-color: #d7e7fe;\n  --accent-quartinary-blue-color: #eef5ff;\n  --accent-quinary-blue-color: #eef5ff;\n\n  /* Exceptional Colors */\n  --accent-exceptional-primary-blue-color: #5095fc;\n  --accent-exceptional-tertiary-blue-color: #d7e7fe;\n  --accent-exceptional-secondary-blue-color: #73abff;\n  --tab-header-progress-bar: #eef5ff;\n  --custom-dots-exceptional: #94a083;\n  --custom-tab-header-color: linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);\n  --custom-tab-header-quiz: linear-gradient(90deg, #5095fc 16.48%, #a0c4f8 103.36%);\n  --bottom-sheet-tab-header-color: linear-gradient(90deg, #5095fc 16.48%, #a0c4f8 103.36%);\n  --vrise-job-card-bg-color: linear-gradient(0deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%),\n    linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);\n  --vrise-application-form-header: linear-gradient(90deg, #5095fc 47.49%, #a0c4f8 121.97%);\n  --vrise-error-container-bg: linear-gradient(180deg, #f1f8ff 0%, #dcebff 45.51%);\n  --vrise-placed-status: linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%),\n    linear-gradient(0deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%);\n  --self-paced-certificate-bg: linear-gradient(90deg, #5095fc 16.48%, #a0c4f8 103.36%);\n  --self-paced-certificate-progress-fill: #fdfdfd;\n  --self-paced-certificate-progress-bg: #5095fc;\n  --self-paced-certificate: #EEF5FF;\n  --self-paced-expiry-time-warning: linear-gradient(269deg, #fdfbf3 2.09%, #fff7d7 110.8%);\n  --self-paced-expection-text-color: #cb9100;\n  --self-paced-exception-red-bg-color: linear-gradient(93deg, #ffc2c2 -3.6%, #ffefd7 97.6%);\n  /* Accent Yellow Color */\n  --accent-primary-yellow-color: #cb9100;\n  --accent-secondary-yellow-color: #f9b300;\n  --accent-tertiary-yellow-color: #ffefc8;\n\n  /* Accent Orange Color */\n  --accent-primary-orange-color: #e06915;\n  --accent-secondary-orange-color: #fe986d;\n  --accent-tertiary-orange-color: #ffe4cc;\n\n  /* Accent Purple Color */\n  --accent-primary-purple-color: #7100a5;\n  --accent-secondary-purple-color: #cc67ff;\n  --accent-tertiary-purple-color: #f1d9fc;\n\n  /* Accent Dark Green Color */\n  --accent-primary-dark-green-color: #3c9455;\n  --accent-secondary-dark-green-color: #e2f3e7;\n\n  /*Accent Red Color */\n  --accent-primary-red-color: #ef5054;\n  --accent-secondary-red-color: #fff1f1;\n\n  /* Accent Green Color */\n  --accent-primary-green-color: #62c659;\n  --accent-secondary-green-color: #8af37c;\n  --accent-tertiary-green-color: #ccffcb;\n\n  /* careers mock interview cards light mode gradients */\n  --scheduled-mock-bg: linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);\n  --cleared-mock-bg: linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%);\n  --missed-mock-bg: linear-gradient(93deg, #ffefd7 -3.6%, #ffc2c2 97.6%);\n\n  /*Home page Banner gradient */\n  --home-page-join-now: linear-gradient(91deg, #ea636d 19.11%, #f59ba0 85.37%);\n  --home-page-refer-earn: linear-gradient(91deg, #6c72db 19.11%, #acb1f9 85.37%);\n  --home-page-elective-selector: linear-gradient(90deg, #5095fc 100%, #a0c4f8 100%);\n  --home-page-live-class-banner-status: #fff1f1;\n  --home-page-refer-earn-banner-status: #f1d9fc;\n  --home-page-elective-selector-status: #d7e7fe;\n  --home-page-banner-time: #fdfdfd;\n  --refer-earn-banner-strip: linear-gradient(90deg, #5095fc 0%, #4652ad 100%);\n  --skill-test-ai-tabs: #fdfdfd;\n\n  /* additional gradients */\n  --homepage-dropdown-gradient: linear-gradient(90deg, #5095fc 16.33%, #a0c4f8 132.4%);\n  --profile-tab-header-gradient: linear-gradient(90deg, #5095fc 16.48%, #a0c4f8 103.36%);\n  --assignment-text-box-gradient: linear-gradient(180deg, #fdfdfd 60.16%, #fdfdfd 112.5%);\n  --quiz-box-linear-gradient: linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%);\n  --quiz-box-attempt-linear-gradient: linear-gradient(93deg, #d7fff8 -3.6%, #cdebfb 45.24%, #c2d5ff 97.6%),\n    var(--Color-Surface-Secondary, #f2f4fa);\n  --quiz-grade-text-linear-gradient: #5d6c83;\n\n  /* Refer and Earn */\n  --refer-earn-main-surface: linear-gradient(180deg, #dee9ff 0%, #f9fbff 100%);\n  --refer-earn-form-surface: #ffffff;\n  --refer-earn-form-heading: linear-gradient(180deg, #5095fc 0%, #99bbed 100%);\n  --refer-earn-form-bg: #ffffff;\n  --refer-earn-benefit-container: #e9f2ff;\n  /* extras */\n  --forum-confirmation-drop-shadow: rgba(253, 253, 253, 0.7);\n  --feedback-widget-gradient: linear-gradient(180deg, rgba(247, 250, 255, 0) 0%, #ebf3ff 41.67%);\n  --toast-warning-gradient: linear-gradient(93deg, #fffac9 -3.6%, #ffdfa1 97.6%);\n  --profile-side-arrow: linear-gradient(270deg, #f7faff 23.33%, rgba(247, 250, 255, 0) 150.83%);\n  --profile-success-gradient-bg: linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);\n  --prt-bg-color: linear-gradient(0deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.6) 100%),\n    linear-gradient(274deg, #c2d5ff -17.2%, #d7fff8 136.15%);\n\n  /* PRT Skill test Gradient */\n  --prt-skill-test-good: linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%);\n  --prt-skill-test-average: linear-gradient(274deg, #ffd290 -17.2%, #fff7d7 136.15%);\n  --prt-skill-test-bad: linear-gradient(93deg, #ffefd7 -3.6%, #ffc2c2 97.6%);\n  --prt-skill-test-tab-header: #f7faff;\n  --prt-skill-test-border-color: #fdfdfd;\n  --vlearn-walkthrough: linear-gradient(to right, #e3a8ff -2.04%, #5095fc 100%);\n\n  /*Excel */\n  --excel-grid-bg: #dcffdb;\n}\n\n[data-theme=\"dark\"] {\n  /* Text Colors */\n  --bg-color: #121212;\n  --primary-text-color: #ffffff;\n  --secondary-text-color: #d3d3d3;\n  --tertiary-text-color: #c8c8c8;\n  --quartinary-text-color: #a8a8a8;\n  --quinary-text-color: #646464;\n\n  /* Surface Color */\n  --main-surface-color: #121212;\n  --primary-surface-color: #1e1e1e;\n  --secondary-surface-color: #232323;\n  --tertiary-surface-color: #2a2a2a;\n  --quartinary-surface-color: #333333;\n\n  /* Border Color */\n  --border-color: #3c3c3c;\n  --border-color-selected: #a8a8a8;\n\n  /* Accent Blue Color */\n  --accent-primary-blue-color: #5095fc;\n  --accent-secondary-blue-color: #5676a1;\n  --accent-tertiary-blue-color: #4a668d;\n  --accent-quartinary-blue-color: #eef5ff;\n  --accent-quinary-blue-color: #333333;\n\n  /* Exceptional Colors */\n  --accent-exceptional-primary-blue-color: #d7e7fe;\n  --accent-exceptional-tertiary-blue-color: #2a2a2a;\n  --accent-exceptional-secondary-blue-color: #7fa4dc;\n  --custom-dots-exceptional: #333333;\n  --custom-tab-header-color: #2a2a2a;\n  --custom-tab-header-quiz: #2a2a2a;\n  --bottom-sheet-tab-header-color: #2a2a2a;\n  --tab-header-progress-bar: #4a668d;\n  --self-paced-certificate: #73abff;\n  --self-paced-certificate-bg: linear-gradient(90deg, #1c2441 -2.26%, #000b26 100%);\n  --self-paced-certificate-progress-fill: #5095fc;\n  --self-paced-certificate-progress-bg: #4a668d;\n  --self-paced-expiry-time-warning: linear-gradient(92deg, #453621 1.42%, #28231b 100.29%);\n  --self-paced-expection-text-color: #ffcc49;\n  --self-paced-exception-red-bg-color: linear-gradient(111deg, #452121 5.2%, #2a241c 96.2%);\n  /* Accent Yellow Color */\n  --accent-primary-yellow-color: #fff0c0;\n  --accent-secondary-yellow-color: #ffcc49;\n  --accent-tertiary-yellow-color: #b5842a;\n\n  /* Accent Orange Color */\n  --accent-primary-orange-color: #ffddc0;\n  --accent-secondary-orange-color: #ff9365;\n  --accent-tertiary-orange-color: #c15436;\n\n  /* Accent Purple Color */\n  --accent-primary-purple-color: #f1d9fc;\n  --accent-secondary-purple-color: #b37cf3;\n  --accent-tertiary-purple-color: #694a8d;\n\n  /* Accent Dark Green Color */\n  --accent-primary-dark-green-color: #37da66;\n  --accent-secondary-dark-green-color: #47594c;\n\n  /*Accent Red Color */\n  --accent-primary-red-color: #ff6a71;\n  --accent-secondary-red-color: #594747;\n\n  /*Accent Green Color */\n  --accent-primary-green-color: #dafcd9;\n  --accent-secondary-green-color: #7cf38a;\n  --accent-tertiary-green-color: #4c8d4a;\n\n  // careers mock interview cards dark mode gradients\n  --scheduled-mock-bg: linear-gradient(114deg, #488f82 3.61%, #3c3c3c 97.06%);\n  --cleared-mock-bg: linear-gradient(114deg, #53895c 3.61%, #3c3c3c 97.06%);\n  --missed-mock-bg: linear-gradient(114deg, #9f4a4a 3.61%, #3c3c3c 97.06%);\n\n  /*Home page Banner gradient */\n  --home-page-join-now: linear-gradient(92deg, #481a1a 0%, #3e0000 64.67%);\n  --home-page-refer-earn: linear-gradient(90deg, #2c1b40 -2.26%, #160025 100%);\n  --home-page-elective-selector: linear-gradient(90deg, #1c2441 -2.26%, #000b26 100%);\n  --home-page-live-class-banner-status: #ff6a71;\n  --home-page-refer-earn-banner-status: #b37cf3;\n  --home-page-elective-selector-status: #5095fc;\n  --home-page-banner-time: #d3d3d3;\n\n  /* additional gradients */\n  --homepage-dropdown-gradient: #333333;\n  --profile-tab-header-gradient: #2a2a2a;\n  --assignment-text-box-gradient: \"\";\n  --quiz-box-linear-gradient: linear-gradient(114deg, #53895c 3.61%, #3c3c3c 97.06%);\n  --quiz-box-attempt-linear-gradient: linear-gradient(114deg, #488f82 3.61%, #3c3c3c 97.06%);\n  --quiz-grade-text-linear-gradient: #ffffff;\n\n  /* Refer and Earn */\n  --refer-earn-main-surface: linear-gradient(180deg, #001a3d 0%, #121212 100%);\n  --refer-earn-form-surface: \"\";\n  --refer-earn-form-heading: #2a2a2a;\n  --refer-earn-form-bg: #1e1e1e;\n  --refer-earn-benefit-container: #333333;\n  /* extras */\n  --forum-confirmation-drop-shadow: rgba(0, 0, 0, 0.7);\n  --feedback-widget-gradient: transparent;\n  --darktheme-loader-bg: #2a2a2a;\n  --darktheme-loader-foreground: #1e1e1e;\n  --refer-earn-banner-strip: #5676a1;\n  --toast-warning-gradient: linear-gradient(114deg, #9f8e4a 3.61%, #3c3c3c 97.06%);\n  --profile-side-arrow: \"\";\n  --profile-success-gradient-bg: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),\n    linear-gradient(90deg, #394b84 -2.26%, #00154b 100%);\n  --skill-test-ai-tabs: #5676a1;\n  --prt-bg-color: #232323;\n\n  /* PRT Skill test Gradient */\n  --prt-skill-test-good: linear-gradient(117deg, #53895c 3.44%, #3c3c3c 155.25%);\n  --prt-skill-test-average: linear-gradient(117deg, #af8952 3.43%, #3c3c3c 143.98%);\n  --prt-skill-test-bad: linear-gradient(118deg, #9f4a4a 3.37%, #3c3c3c 141.01%);\n  --prt-skill-test-tab-header: #1e1e1e;\n  --prt-skill-test-border-color: #3c3c3c;\n  --vlearn-walkthrough: linear-gradient(to right, #d377ff -2.04%, #67a4ff 100%);\n  --excel-grid-bg: #4c8d4a;\n  --vrise-job-card-bg-color: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),\n    linear-gradient(90deg, #394b84 -2.26%, #00154b 100%);\n  --vrise-application-form-header: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),\n    linear-gradient(90deg, #394b84 -2.26%, #00154b 100%);\n\n  --vrise-error-container-bg: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),\n    linear-gradient(180deg, #394b84 0%, #00154b 100%);\n\n  --vrise-placed-status: linear-gradient(143deg, #266731 -96.5%, #1e1e1e 107.44%);\n}\n","@import './mixins.scss';\n@import './themeMapping.scss';\n\n* {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.full-height {\n  height: calc(100vh - 90px);\n}\np {\n  margin: 0;\n  padding: 0;\n}\n// .slider-container {\n//   overflow: hidden;\n//   position: relative;\n// }\n.bounceInRight {\n  -webkit-animation-name: bounceInRight;\n  animation-name: bounceInRight;\n}\n.custom-loader {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10;\n}\n.icon-filled {\n  font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 48;\n}\n.no-pointer {\n  cursor: not-allowed !important;\n}\n.zoom-join-button-text {\n  @include SemiSans;\n  cursor: pointer;\n}\n.Course-card-header-program-name-text {\n  @include MediumSans;\n  color: #333b48;\n  text-transform: capitalize;\n  text-overflow: ellipsis;\n  white-space: normal;\n  font-size: 16px;\n}\n.Course-card-header {\n  @media (max-width: 769px) {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    .Course-card-header-program-name-text {\n      font-size: 14px;\n    }\n    .course-card-img {\n      width: 70px;\n    }\n\n    .Course-card-header-middle-column {\n      flex-grow: 1;\n    }\n    .Course-card-header-program-name {\n      max-width: auto !important;\n    }\n  }\n}\n.d-none {\n  display: none !important;\n}\n.d-block {\n  display: block !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.w-100 {\n  width: 100% !important;\n}\n.h-100 {\n  height: 100% !important;\n}\n.vh-100 {\n  height: 100vh !important;\n}\n.vw-100 {\n  width: 100vw !important;\n}\n\n/* Flexbox Utilities */\n.flex-row {\n  flex-direction: row !important;\n}\n.flex-column {\n  flex-direction: column !important;\n}\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n.justify-content-center {\n  justify-content: center !important;\n}\n.justify-content-between {\n  justify-content: space-between !important;\n}\n.justify-content-around {\n  justify-content: space-around !important;\n}\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n.align-items-start {\n  align-items: flex-start !important;\n}\n.align-items-end {\n  align-items: flex-end !important;\n}\n.align-items-center {\n  align-items: center !important;\n}\n.align-items-baseline {\n  align-items: baseline !important;\n}\n.align-items-stretch {\n  align-items: stretch !important;\n}\n.align-content-start {\n  align-content: flex-start !important;\n}\n.align-content-end {\n  align-content: flex-end !important;\n}\n.align-content-center {\n  align-content: center !important;\n}\n.align-content-between {\n  align-content: space-between !important;\n}\n.align-content-around {\n  align-content: space-around !important;\n}\n.align-content-stretch {\n  align-content: stretch !important;\n}\n.align-self-auto {\n  align-self: auto !important;\n}\n.align-self-start {\n  align-self: flex-start !important;\n}\n.align-self-end {\n  align-self: flex-end !important;\n}\n.align-self-center {\n  align-self: center !important;\n}\n.align-self-baseline {\n  align-self: baseline !important;\n}\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n/* Margin and Padding Utilities */\n.m-0 {\n  margin: 0 !important;\n}\n.m-1 {\n  margin: 0.25rem !important;\n}\n.m-2 {\n  margin: 0.5rem !important;\n}\n.m-3 {\n  margin: 1rem !important;\n}\n.m-4 {\n  margin: 1.5rem !important;\n}\n.m-5 {\n  margin: 3rem !important;\n}\n.m-auto {\n  margin: auto !important;\n}\n/* Other margin classes omitted for brevity */\n\n.p-0 {\n  padding: 0 !important;\n}\n.p-1 {\n  padding: 0.25rem !important;\n}\n.p-2 {\n  padding: 0.5rem !important;\n}\n.p-3 {\n  padding: 1rem !important;\n}\n.p-4 {\n  padding: 1.5rem !important;\n}\n.p-5 {\n  padding: 3rem !important;\n}\n/* Other padding classes omitted for brevity */\n\n/* Display Utilities */\n.d-inline {\n  display: inline !important;\n}\n.d-inline-block {\n  display: inline-block !important;\n}\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n.d-table-row {\n  display: table-row !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.d-inline-flex {\n  display: inline-flex !important;\n}\n.d-none {\n  display: none !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n.w-auto {\n  width: auto !important;\n}\np {\n  margin-bottom: 1rem;\n}\n/* Padding Top */\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n.pt-3 {\n  padding-top: 1rem !important;\n}\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n/* Padding Left */\n.pl-0 {\n  padding-left: 0 !important;\n}\n.pl-1 {\n  padding-left: 0.25rem !important;\n}\n.pl-2 {\n  padding-left: 0.5rem !important;\n}\n.pl-3 {\n  padding-left: 1rem !important;\n}\n.pl-4 {\n  padding-left: 1.5rem !important;\n}\n.pl-5 {\n  padding-left: 3rem !important;\n}\n\n/* Padding Bottom */\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n/* Padding Right */\n.pr-0 {\n  padding-right: 0 !important;\n}\n.pr-1 {\n  padding-right: 0.25rem !important;\n}\n.pr-2 {\n  padding-right: 0.5rem !important;\n}\n.pr-3 {\n  padding-right: 1rem !important;\n}\n.pr-4 {\n  padding-right: 1.5rem !important;\n}\n.pr-5 {\n  padding-right: 3rem !important;\n}\n\n/* Margin Top */\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n.mt-3 {\n  margin-top: 1rem !important;\n}\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n/* Margin Bottom */\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n/* Margin Left */\n.ml-0 {\n  margin-left: 0 !important;\n}\n.ml-1 {\n  margin-left: 0.25rem !important;\n}\n.ml-2 {\n  margin-left: 0.5rem !important;\n}\n.ml-3 {\n  margin-left: 1rem !important;\n}\n.ml-4 {\n  margin-left: 1.5rem !important;\n}\n.ml-5 {\n  margin-left: 3rem !important;\n}\n\n/* Margin Right */\n.mr-0 {\n  margin-right: 0 !important;\n}\n.mr-1 {\n  margin-right: 0.25rem !important;\n}\n.mr-2 {\n  margin-right: 0.5rem !important;\n}\n.mr-3 {\n  margin-right: 1rem !important;\n}\n.mr-4 {\n  margin-right: 1.5rem !important;\n}\n.mr-5 {\n  margin-right: 3rem !important;\n}\n\nh1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh2 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh3 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh4 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh5 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\np {\n  margin: 0;\n  padding: 0;\n}\n\n.slick-dots .slick-active .customDots {\n  width: 28px !important;\n  background: #5095fc !important;\n}\n.slick-dots {\n  bottom: -16px !important;\n  li {\n    margin: 0 8px !important;\n    width: fit-content !important;\n    height: fit-content !important;\n  }\n  li:first-child {\n    margin-right: 0px !important;\n  }\n}\n.zoom-mobile-view {\n  height: 100vh;\n  width: 100vw;\n  @include flex(column);\n  overflow: hidden;\n  background: linear-gradient(249deg, #c2d5ff 26%, #d7fff8 73.92%);\n  &-img {\n    @include flex();\n    padding: 16px;\n  }\n}\n.zoom-trying-img {\n  width: 100%;\n\n  @supports (-webkit-touch-callout: none) {\n    height: calc(100vh - 450px);\n    object-fit: contain;\n  }\n  height: calc(100vh - 420px);\n  // object-fit: contain;\n  // @media screen and (min-height: 850px) {\n  //   height: calc(100vh - 420px);\n  //   height: calc(100svh - 420px);\n  // }\n  @media screen and (min-height: 730px) {\n    height: 45vh;\n    padding-top: 60px;\n    // height: calc(100svh - 450px);\n  }\n  @media screen and (min-height: 850px) {\n    height: 45vh;\n    padding-top: 80px;\n    // height: calc(100svh - 450px);\n  }\n}\n.zoom-mobile-img {\n  flex-grow: 1;\n  @include flex(column, center, flex-start);\n  // margin-top: 18px;\n  .zoom-background-img {\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: top;\n    background-size: cover;\n  }\n}\n\n.zoom-mobile-bottom-container {\n  flex-grow: 1;\n  @include flex(column, center, flex-start);\n  height: 320px;\n  width: 100vw;\n\n  @media screen and (min-height: 820px) {\n    height: 42vh;\n    // justify-content: space-between;\n  }\n  padding: 28px 16px 24px 16px;\n  gap: 24px;\n  background-color: white;\n  border-radius: 30px 30px 0px 0px;\n  border: 2px solid var(--Color-Surface-Primary, #fdfdfd);\n  background: #f0f4ff;\n  box-shadow: 0px -4px 16px 0px rgba(147, 172, 214, 0.3);\n  p {\n    margin: 0;\n    padding: 0;\n  }\n  .zoom-mobile-heading {\n    color: #5095fc;\n    font-size: 20px;\n    @include SemiSans;\n    line-height: 125%;\n    width: 100%;\n    text-align: center;\n  }\n  .zoom-mobile-subHeading {\n    color: #000;\n    text-align: center;\n    font-size: 14px;\n    line-height: 150%;\n    margin-top: 12px;\n    @include RegularSans;\n    color: var(--Color-Text-Primary, #333b48);\n    text-align: center;\n  }\n  .app-store-button {\n    @include flex();\n    width: 100%;\n    gap: 16px;\n\n    img {\n      width: 167px;\n      @include m_mobile {\n        width: 40vw;\n      }\n    }\n  }\n  .continue-browser {\n    color: rgba(0, 0, 0, 0.6);\n    text-align: center;\n    font-family: 'Roboto';\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    text-decoration-line: underline;\n    cursor: pointer;\n    @include remove_userTapColor;\n  }\n  .or-button {\n    color: rgba(0, 0, 0, 0.5);\n    text-align: center;\n    font-family: 'Roboto';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 18px */\n  }\n}\n\n.left-short-img {\n  @include flex(column);\n  .left-short-img-container {\n    @include flex(column, flex-start, flex-start);\n    gap: 24px;\n    padding: 0 40px;\n    .app-store-button {\n      @include flex(row, flex-start, flex-start);\n      gap: 16px;\n      flex-wrap: wrap;\n      img {\n        width: 160px;\n        height: 52px;\n      }\n    }\n  }\n  img {\n    width: 192px;\n    height: 34px;\n  }\n  h6 {\n    color: var(--Color-Accent-Shade-1, #5095fc);\n    @include SemiSans;\n    font-size: 32px;\n    line-height: 125%;\n    margin: 0;\n  }\n  p {\n    margin: 0;\n    margin-top: 12px;\n    color: var(--Color-Text-Primary, #333b48);\n    @include RegularSans;\n    font-size: 18px;\n    line-height: 150%;\n  }\n  @include respond-to(765px) {\n    h6 {\n      font-size: 24px;\n    }\n    p {\n      font-size: 16px;\n    }\n  }\n}\n\ninput {\n  background-color: var(--primary-surface-color) !important;\n  &::placeholder {\n    color: #94A0B3 !important;\n  }\n}\n","@mixin flex($direction: row, $align-items: center, $justify-content: center) {\n  display: flex;\n  flex-direction: $direction;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n@mixin container {\n  margin: auto;\n  max-width: 1920px;\n}\n\n@mixin s_container {\n  max-width: 1536px;\n  margin: 0 auto;\n  padding: 0 32px;\n\n  @include l_desktop {\n    max-width: 1320px;\n  }\n\n  @include s_tablet {\n    padding: 0 16px;\n  }\n}\n\n@mixin box($width, $height: $width) {\n  width: $width;\n  height: $height;\n}\n\n// FONT ISSUE NOT MATCHING NEED TO GRAB NEW FONTS\n@mixin RegularSans {\n  font-family: 'Regular Sans', sans-serif;\n  font-style: normal;\n}\n@mixin MediumSans {\n  font-family: 'Medium Sans', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n}\n@mixin SemiSans {\n  font-family: 'Semi Sans', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n}\n@mixin BoldSans {\n  font-family: 'Bold Sans', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n}\n@mixin IBMPlexMonoMedium {\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: 500;\n  font-style: normal;\n}\n\n\n@mixin auth-heading {\n  @include Playfair;\n  line-height: 1.875rem;\n  font-weight: 600;\n  letter-spacing: -3%;\n  font-size: 2rem;\n  @include s_tablet {\n    font-size: 1.8rem;\n  }\n}\n\n@mixin auth-subheading {\n  @include Inter;\n  line-height: 1.875rem;\n  font-weight: 400;\n  font-size: 1rem;\n  @include s_tablet {\n    font-size: 0.9rem;\n  }\n}\n@mixin validation-text {\n  color: #ff0000;\n  font-size: 0.875rem;\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n@mixin respond-to($max-width) {\n  @media (max-width: $max-width) {\n    @content;\n  }\n}\n@mixin respond-to-min($max-width) {\n  @media (min-width: $max-width) {\n    @content;\n  }\n}\n\n@mixin respond-to-height($max-height) {\n  @media (max-height: $max-height) {\n    @content;\n  }\n}\n\n@mixin larger_desktop {\n  @media (min-width: 1920px) {\n    @content;\n  }\n}\n@mixin l_desktop {\n  @media (min-width: 1536px) {\n    @content;\n  }\n}\n\n@mixin sm_desktop {\n  @media (max-width: 1350px) {\n    @content;\n  }\n}\n\n@mixin m_desktop {\n  @media (max-width: 1199px) {\n    @content;\n  }\n}\n\n@mixin s_desktop {\n  @media (max-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin l_tablet {\n  @media (max-width: 991px) {\n    @content;\n  }\n}\n\n@mixin m_tablet {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm_tablet {\n  @media (min-width: 601px) and (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin s_tablet {\n  @media (max-width: 550px) {\n    @content;\n  }\n}\n@mixin l_mobile {\n  @media (max-width: 425px) {\n    @content;\n  }\n}\n@mixin m_mobile {\n  @media (max-width: 375px) {\n    @content;\n  }\n}\n@mixin s_mobile {\n  @media (max-width: 350px) {\n    @content;\n  }\n}\n@mixin xs_mobile {\n  @media (max-width: 300px) {\n    @content;\n  }\n}\n@mixin safari_specific_style {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n@mixin hide_scrollbar {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  & {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n}\n\n@mixin underline_animation {\n  overflow: hidden;\n  background: linear-gradient(currentColor 0 0) 0 100% / var(--d, 0) 1px\n    no-repeat;\n  transition: 0.5s;\n  &:hover {\n    --d: 100%;\n  }\n}\n\n@mixin bounceInRight($duration: 0.5s) {\n  @-webkit-keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  @keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n}\n\n@mixin bounceOutRight($duration: 0.5s) {\n  @-webkit-keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      -webkit-transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n  }\n\n  @keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(2000px);\n    }\n  }\n\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@mixin remove_userTapColor {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@mixin ellipsis($line: 4) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: $line; /* Set the number of lines to be shown */\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
